import * as types from './mutation-types'

export const documentGetFolderTree = ({ commit }) => {
  return new Promise((resolve, reject) => {
    Vue2.prototype.$api.active().get('folders', {
      params: {
        include: 'tree',
      },
    }).then((response) => {
      commit(types.DOCUMENT_SET_TOP_LEVEL_FOLDERS, response.data)
      resolve()
    }).catch((errors) => {
      reject(errors)
    })
  })
}

export const documentGetFolderDetails = ({ commit }, FolderUuid) => {
  return new Promise((resolve, reject) => {
    Vue2.prototype.$api.active().get('folders/' + FolderUuid, {
      params: {
        include: 'parent,documents,folders.parent,folder.descendants,ancestors,descendants',
      },
    }).then((response) => {
      commit(types.DOCUMENT_SET_FOLDER, response.data)
      resolve()
    }).catch((errors) => {
      reject(errors)
    })
  })
}


export const documentSendResourceToGroups = ({ commit }, { sharedItemMode, resource, payload }) => {
  let url = resource._type.toLowerCase() + 's/' + resource.uuid + '/visibilities/groups'
  if (sharedItemMode) {
    // noinspection FallThroughInSwitchStatementJS
    switch (resource._type.toLowerCase()) {
      case 'shareddocument':
      case 'document':
        url = '/shares/documents/' + resource.uuid + '/visibilities/membership-groups'
      case 'sharedfolder':
      case 'folder':
        url = '/shares/folders/' + resource.uuid + '/visibilities/membership-groups'
      default:
        throw 'Could not build shared url'
    }
  }
  return Vue2.prototype.$api.active().post(url, payload).then((response) => {
    commit('baseAddNotification', {
      type: 'success',
      title: 'Success',
      text: resource._type + ' sent to group!',
    })
    return response
  }).catch((errors) => {
    commit('baseAddNotification', {
      type: 'error',
      text: 'There was an error sharing.',
      timeout: false,
    })
    reject(errors)
  })
}


export const documentSendResourceToMembers = ({ commit }, { sharedItemMode, resource, payload }) => {
  let url = resource._type.toLowerCase() + 's/' + resource.uuid + '/visibilities/memberships'
  if (sharedItemMode) {
    // noinspection FallThroughInSwitchStatementJS
    switch (resource._type.toLowerCase()) {
      case 'shareddocument':
      case 'document':
        url = '/shares/documents/' + resource.uuid + '/visibilities/memberships'
      case 'sharedfolder':
      case 'folder':
        url = '/shares/folders/' + resource.uuid + '/visibilities/memberships'
      default:
        throw 'Could not build shared url'
    }
  }
  return Vue2.prototype.$api.active().post(url, payload).then((response) => {
    commit('baseAddNotification', {
      type: 'success',
      title: 'Success',
      text: resource._type + ' sent to group!',
    })
    return response
  }).catch((errors) => {
    commit('baseAddNotification', {
      type: 'error',
      text: 'There was an error sharing.',
      timeout: false,
    })
    reject(errors)
  })
}
export const documentGetFavoriteDocuments = ({ commit }) => {
  return new Promise((resolve, reject) => {
    Vue2.prototype.$api.active().get('documents/favorites', {
      params: {
        include: 'folder',
      },
    }).then((response) => {
      commit(types.DOCUMENT_SET_FAVORITE_DOCUMENTS, response.data)
      resolve()
    })
  })
}

export const documentGetPendingShareCounts = ({ commit }) => {
  return new Promise((resolve, reject) => {
    Vue2.prototype.$api.active().get('shares/pending/count')
      .then((response) => {
        commit(types.DOCUMENT_SET_PENDING_SHARE_COUNTS, response.data)
        resolve()
      }).catch((errors) => {
        resolve(errors)
      })
  })
}